
// 按当前页面域名判断环境（运行时判断，与 utils.ts 的 isProd() 一致）：
//   线上 osm.dianping.com → https://poseidon.dianping.com
//   测试 osm.51ping.com 等 → https://poseidon.51ping.com
// 注意：同一份构建产物会同时部署到测试与线上，必须用页面域名判断、
// 不能用构建期 DEPLOY_ENV（否则测试环境也会命中 prod 分支）。
const isProdHost = typeof window !== 'undefined'
  && window.location.hostname.includes('osm.dianping.com')

export const REQUEST_HOST = isProdHost
  ? 'https://poseidon.dianping.com'
  : 'https://poseidon.51ping.com'
